import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'
import { propAccessor } from '@hc-frontend/utils'

const responseOnError = {
  data: []
}

function getActiveApplications(hcStorage) {
  const email = encodeURIComponent(propAccessor(hcStorage, 'contact.email_address', ''))
  const stringDOB = propAccessor(hcStorage, 'members.0.stringDOB', '')

  return email && stringDOB
    ? fetchJSONHandleError({
        url: `${BACKEND_PIVOT}/applications-by-member?email=${email}&dob=${stringDOB}`,
        responseOnError
      })
    : Promise.resolve(responseOnError)
}

export default getActiveApplications
